module.exports = __webpack_public_path__ + "31e41e51fab1445200a58881d1b9333c.svg";